import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FiArrowRight,
  FiCheckCircle,
  FiEye,
  FiEyeOff,
  FiLock,
  FiMail,
  FiShield,
  FiUser,
  FiZap,
} from 'react-icons/fi';
import API from '../api';
import { AuthBrand, AuthFinancialPreview } from './AuthShell';

export default function RegisterPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ first_name: '', last_name: '', email: '', confirm_email: '', password: '' });
  const [error, setError] = useState(null);
  const [isRegistering, setIsRegistering] = useState(false);
  const [showRegisterPassword, setShowRegisterPassword] = useState(false);

  const handleInput = (event) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleRegister = async (event) => {
    event.preventDefault();
    if (isRegistering) return;
    setIsRegistering(true);
    try {
      await API.post('/register/', form);
      navigate('/verify', { state: { email: form.email } });
    } catch (err) {
      console.error(err);
      const emailErr = err.response?.data?.email;
      if (emailErr) {
        setError(Array.isArray(emailErr) ? emailErr[0] : emailErr);
      } else {
        setError("Erreur lors de l'inscription. Veuillez réessayer.");
      }
    } finally {
      setIsRegistering(false);
    }
  };

  return (
    <main className="auth-container auth-container--register">
      <div className="auth-layout">
        <aside className="auth-showcase" aria-label="Présentation Adabo Cash">
          <div className="auth-showcase__orb auth-showcase__orb--one" aria-hidden="true" />
          <div className="auth-showcase__orb auth-showcase__orb--two" aria-hidden="true" />
          <div className="auth-showcase__content">
            <AuthBrand />
            <div className="auth-showcase__copy">
              <span className="auth-eyebrow"><FiZap /> Commencez aujourd'hui</span>
              <h1>Prenez le contrôle<br />de vos finances.</h1>
              <p>Créez votre compte en quelques instants et accédez à tous vos services.</p>
            </div>
            <AuthFinancialPreview />
            <div className="auth-benefits">
              <span><FiShield /> Données protégées</span>
              <span><FiCheckCircle /> Inscription rapide</span>
            </div>
          </div>
        </aside>

        <section className="auth-card">
          <div className="auth-card__mobile-brand"><AuthBrand /></div>
          <header className="auth-card__header">
            <h2>Créez votre compte</h2>
            <p>Renseignez vos informations pour commencer.</p>
          </header>

          {error && <div className="error-message" role="alert">{error}</div>}

          <form onSubmit={handleRegister}>
            <div className="auth-fields-row">
              <div className="auth-field">
                <label htmlFor="register-first-name">Prénom</label>
                <div className="auth-input-wrap">
                  <FiUser aria-hidden="true" />
                  <input id="register-first-name" name="first_name" placeholder="Votre prénom" value={form.first_name} onChange={handleInput} autoComplete="given-name" required />
                </div>
              </div>
              <div className="auth-field">
                <label htmlFor="register-last-name">Nom</label>
                <div className="auth-input-wrap">
                  <FiUser aria-hidden="true" />
                  <input id="register-last-name" name="last_name" placeholder="Votre nom" value={form.last_name} onChange={handleInput} autoComplete="family-name" required />
                </div>
              </div>
            </div>

            <div className="auth-field">
              <label htmlFor="register-email">Adresse email</label>
              <div className="auth-input-wrap">
                <FiMail aria-hidden="true" />
                <input id="register-email" name="email" type="email" placeholder="nom@exemple.com" value={form.email} onChange={handleInput} autoComplete="email" required />
              </div>
            </div>

            <div className="auth-field">
              <label htmlFor="register-confirm-email">Confirmez votre email</label>
              <div className="auth-input-wrap">
                <FiMail aria-hidden="true" />
                <input id="register-confirm-email" name="confirm_email" type="email" placeholder="Saisissez à nouveau votre email" value={form.confirm_email} onChange={handleInput} autoComplete="email" required />
              </div>
            </div>

            <div className="auth-field">
              <label htmlFor="register-password">Mot de passe</label>
              <div className="password-field auth-input-wrap">
                <FiLock aria-hidden="true" />
                <input
                  id="register-password"
                  name="password"
                  type={showRegisterPassword ? 'text' : 'password'}
                  placeholder="Créez un mot de passe sécurisé"
                  value={form.password}
                  onChange={handleInput}
                  autoComplete="new-password"
                  required
                />
                <button
                  type="button"
                  className="password-toggle"
                  aria-label={showRegisterPassword ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}
                  onClick={() => setShowRegisterPassword((value) => !value)}
                >
                  {showRegisterPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>

            <button type="submit" className={isRegistering ? 'is-submitting' : ''}>
              <span>{isRegistering ? 'Inscription...' : "Créer mon compte"}</span>
              {!isRegistering && <FiArrowRight aria-hidden="true" />}
            </button>
          </form>

          <div className="auth-links">
            <span>Vous avez déjà un compte&nbsp;?</span>
            <button className="switch-btn" type="button" onClick={() => navigate('/login')}>Se connecter</button>
          </div>
        </section>
      </div>
    </main>
  );
}
